import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { createOsmMap, keepMapSized } from '../utils/osmMap';
import './TrackPreview.css';

const PADDING = [12, 12];

// Мини-карта трека на плитке списка: неподвижная, клики и перетаскивание
// достаются плитке. Создаем ее, только когда плитка доехала до экрана, —
// иначе длинная папка грузит тайлы на все заезды разом
const TrackPreview = ({ points, height = 150 }) => {
  const nodeRef = useRef(null);
  const [visible, setVisible] = useState(typeof IntersectionObserver === 'undefined');
  const hasTrack = (points || []).length > 1;

  useEffect(() => {
    if (visible || !hasTrack || !nodeRef.current) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) setVisible(true);
    }, { rootMargin: '200px' });
    observer.observe(nodeRef.current);
    return () => observer.disconnect();
  }, [visible, hasTrack]);

  useEffect(() => {
    if (!visible || !hasTrack || !nodeRef.current) return undefined;

    const map = createOsmMap(nodeRef.current, {
      prefix: false,
      zoomControl: false,
      dragging: false,
      touchZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: false,
      boxZoom: false,
      keyboard: false,
      zoomSnap: 0.25,
    });
    const line = L.polyline(points, { className: 'track-preview-line', weight: 3, interactive: false }).addTo(map);
    const bounds = line.getBounds();
    map.fitBounds(bounds, { padding: PADDING });
    const stopSizing = keepMapSized(map, nodeRef.current, bounds, PADDING);

    return () => {
      stopSizing();
      map.remove();
    };
  }, [visible, hasTrack, points]);

  if (!hasTrack) return <div className="track-preview" style={{ height }} aria-hidden="true" />;

  return <div ref={nodeRef} className="track-preview" style={{ height }} aria-hidden="true" />;
};

export default TrackPreview;
